export const socketSend = (socket, payload) => {
  const sockeRequest = () => {
    console.info("send to socket: ", payload)
    socket.send(JSON.stringify(payload))
  }
  process.env.API_PROD === "true"
    ? sockeRequest()
    : console.info("log: ", JSON.stringify(payload))
}
